import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useQuery } from "react-query";
import moment from "moment";

import {
  Dashboard,
  MainTable,
  Main,
  Button,
} from "components";
import { parseQuery } from "utils/api";
import {
  getRemarks,
  filterRemarks,
  toggleFilters,
} from "actions/remarks";
import getUsersOptions from "utils/select_options/getUsersOptions";

import { ReactComponent as DangerIcon } from "icons/danger.svg";

const userLabel = (user) =>
  user ? `${user.first_name} ${user.last_name}` : "-";

const RemarkList = ({
  remarks,
  current_user,
  toggleFilters,
  getRemarks,
  filterRemarks,
  history,
  location: { search },
}) => {
  const can_manage =
    current_user?.is_admin || current_user?.can_manage_remarks;
  const { isFetching: is_fetching_users, data: users } = useQuery(
    "users",
    getUsersOptions
  );
  const query = parseQuery(search);
  const [is_loaded, setLoaded] = useState(false);
  const sort = {
    "sort[column]": query["sort[column]"] || "id",
    "sort[order]": query["sort[order]"] || "desc",
  };
  useEffect(() => {
    getRemarks({ ...query, ...sort });
    setLoaded(true);
  }, [search]);
  useEffect(() => {
    if (is_loaded) {
      getRemarks({ ...query, page: undefined });
    }
  }, [remarks.filters.query]);
  if (remarks.status === "failure") {
    return <p>Error</p>;
  }
  const { data, meta } = remarks;
  return (
    <Main
      page={{
        name: "Uwagi",
        icon: <DangerIcon />,
        breadcrumbs: [{ name: "Uwagi" }],
        buttons: can_manage ? (
          <Button
            type="add"
            text="Dodaj uwagę"
            path="/remarks/new"
          />
        ) : null,
      }}>
      <Dashboard>
        <MainTable
          is_loading={
            remarks.status === "invalid" ||
            remarks.status === "loading"
          }
          is_searching={remarks.status === "searching"}
          filters_open={remarks.filters.open}
          toggleFilters={toggleFilters}
          data={data}
          meta={meta}
          sort={sort}
          head={[
            { label: "ID", name: "id" },
            { label: "Treść", name: "content" },
            { label: "Zgłaszający", name: "reporter" },
            { label: "Dotyczy", name: "reported_user" },
            { label: "Zatwierdzona", name: "approved_at" },
          ]}
          empty_text="Brak uwag"
          renderRow={({
            id,
            content,
            reporter,
            reported_user,
            approved_at,
          }) => (
            <tr
              key={id}
              style={{ cursor: "pointer" }}
              onMouseDown={(event) => {
                if (event.button === 1) {
                  window.open(`/remarks/${id}`, "_blank");
                }
              }}
              onClick={() => history.push(`/remarks/${id}`)}>
              <td>{id}</td>
              <td>{content?.length > 80 ? `${content.slice(0, 80)}...` : content}</td>
              <td>{userLabel(reporter)}</td>
              <td>{userLabel(reported_user)}</td>
              <td>
                {approved_at
                  ? moment(approved_at).format("DD.MM.YYYY HH:mm")
                  : "Nie"}
              </td>
            </tr>
          )}
          filtersAction={filterRemarks}
          filters={[
            {
              type: "select",
              label: "Osoba, której dotyczy uwaga",
              name: "reported_user_id",
              search_type: "eq",
              options: users,
              is_loading: is_fetching_users,
            },
          ]}
        />
      </Dashboard>
    </Main>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getRemarks: (data) => dispatch(getRemarks(data)),
  filterRemarks: (data) => dispatch(filterRemarks(data)),
  toggleFilters: () => dispatch(toggleFilters()),
});
export default connect(
  ({ remarks, current_user }) => ({ remarks, current_user }),
  mapDispatchToProps
)(RemarkList);
